"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEV_HOST = exports.STG_HOST = exports.PRD_HOST = void 0;
exports.PRD_HOST = 'w.crmstyle.com';
exports.STG_HOST = 'st-w.crmstyle.com';
exports.DEV_HOST = 'dev-w.crmstyle.com';
